import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel, UIComponentHandler } from '../uicomponent';
import { AlertComponentProps, AlertComponentState, AlertComponentHandler } from './alertcomponent';
import { AlertCSSStyleImpl, AlertCSSStyle } from './alertcss';
import * as React from 'react';
import { ButtonComponent } from '../button/buttoncomponent';
import { AlertButtonCSSStyle } from './alertbuttoncss';
import { ErrorAlertCSSStyle, ErrorAlertCSSStyleImpl } from './erroralertcss';
import { AlertType } from './alerttype';
import { BaseContext } from '../../../utils/basecontext';
import { WarnAlertCSSStyle, WarnAlertCSSStyleImpl } from './warnalertcss';
import { Strings } from '../../../utils/resources/strings';
import './alert-style.css';

export class AlertView extends UIComponentViewImpl<UIDataModel>
{

    private errorCSSStyle:ErrorAlertCSSStyle;
    private warnCSSStyle:WarnAlertCSSStyle;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
        this.errorCSSStyle = new ErrorAlertCSSStyleImpl(this.getContext());
        this.warnCSSStyle = new WarnAlertCSSStyleImpl(this.getContext());
      
    }
    bindHandlers()
    {
      this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
      this.onButtonClick = this.onButtonClick.bind(this);

    
    }
     
    draw(uiProps: AlertComponentProps, uiState: AlertComponentState, cssStyle: AlertCSSStyleImpl): JSX.Element {
       super.draw(uiProps, uiState, cssStyle); 

       return(
        
        <div style={{width:'100%',height:'100%'}}>
            <div id="alert-wrapper">
                                {
                                    this.getWebView(uiProps, uiState, cssStyle)
                                }
                    </div>
                <div id="alert-col-wrapper">
                                {
                                    this.getMobileView(uiProps, uiState, cssStyle)
                                }
                </div>
        </div>
       );

    } 

    getWebView(uiProps: AlertComponentProps, uiState: AlertComponentState, cssStyle: AlertCSSStyleImpl)
    {
        return ( 
            <>
        {uiState.alertType === AlertType.SUCCESS && this.getSuccessAlertView(uiProps,uiState, cssStyle)}
        {uiState.alertType === AlertType.ERROR  &&  this.getErrorAlertView(uiProps, uiState)}
        {uiState.alertType === AlertType.WARN && this.getWarnAlertView(uiProps, uiState)} 
        {uiState.alertType === AlertType.AUTHENTICATE && this.getAuthenticateAlertView(uiProps, uiState)} 
        </>
        );
    }

    getMobileView(uiProps: AlertComponentProps, uiState: AlertComponentState, cssStyle: AlertCSSStyleImpl)
    {
        return ( 
            <>
        {uiState.alertType === AlertType.SUCCESS && this.getMobileSuccessAlertView(uiProps,uiState, cssStyle)}
        {uiState.alertType === AlertType.ERROR  &&  this.getMobileErrorAlertView(uiProps, uiState)}
        {uiState.alertType === AlertType.WARN && this.getMobileWarnAlertView(uiProps, uiState)} 
        {uiState.alertType === AlertType.AUTHENTICATE && this.getMobileAuthenticateAlertView(uiProps, uiState)} 
        </>
        );
    }

    private getSuccessAlertView(uiProps:AlertComponentProps,uiState:AlertComponentState,cssStyle:AlertCSSStyle):JSX.Element
    {
        return(
            <div style={cssStyle.getWrapperCSSStyle()}>
            <div id="alert-inner-wrapper" style={cssStyle.getInnerWrapperCSSStyle()}>
                <div  onClick={this.onCloseButtonClick} style={cssStyle.getCloseButtonDivCSSStyle()}>
                        <img width='20px' height='20px' src={this.getContext().getResources().getImage("close.svg")}/>
                </div>
                {/* <div style={cssStyle.getAlertImageDivCSSStyle()}>
                    <img width='150px' height='150px' src={this.getContext().getResources().getImage("successcheck.svg")}/>
                </div> */}
                 <div style={{width:"100%", display:"none",height:"30px",textAlign:"center",lineHeight:"30px",fontSize:"25px",fontWeight:900,color:"#000000",marginBottom:"30px"}}>
                    <label>{this.getContext().getResources().getString(Strings.alert_success)}</label>
                </div>
                <div style={cssStyle.getAlertMessageDivCSSStyle()}>
                        {uiState.alertMessage}
                </div>
                <div onClick={this.onButtonClick} style={cssStyle.getButtonDivCSSStyle()}>
                    <ButtonComponent onClick={this.onButtonClick} style={new AlertButtonCSSStyle(uiProps.context, "#FFFFFF")} context={uiProps.context} label={uiState.buttonTitle}/>

                </div>

            </div>
           
       </div>
        );
            
    }

    private getErrorAlertView(uiProps:AlertComponentProps, uiState:AlertComponentState):JSX.Element
    {
        return(
            <div  style={this.errorCSSStyle.getWrapperCSSStyle()}>
            <div id="alert-inner-wrapper" style={this.errorCSSStyle.getInnerWrapperCSSStyle()}>
                <div  onClick={this.onCloseButtonClick} style={this.errorCSSStyle.getCloseButtonDivCSSStyle()}>
                        <img width='20px' height='20px' src={this.getContext().getResources().getImage("close.svg")}/>
                </div>
                {/* <div style={this.errorCSSStyle.getAlertImageDivCSSStyle()}>
                    <img width='150px' height='150px' src={this.getContext().getResources().getImage("errorcircle.svg")}/>
                </div> */}
                <div style={{width:"100%", display:"none",height:"30px",textAlign:"center",lineHeight:"30px",fontSize:"25px",fontWeight:900,color:"#000000",marginBottom:"30px"}}>
                    <label>{this.getContext().getResources().getString(Strings.alert_error)}</label>
                </div>

                <div style={this.errorCSSStyle.getAlertMessageDivCSSStyle()}>
                        {uiState.alertMessage}
                </div>
                <div onClick={this.onButtonClick} style={this.errorCSSStyle.getButtonDivCSSStyle()}>
                    <ButtonComponent onClick={this.onButtonClick} style={new AlertButtonCSSStyle(uiProps.context, "#FFFFFF")} context={uiProps.context} label={uiState.buttonTitle}/>

                </div>

            </div>
           
       </div>
        );
    }

    private getWarnAlertView(uiProps:AlertComponentProps,uiState:AlertComponentState):JSX.Element
    {
        return(
            <div style={this.warnCSSStyle.getWrapperCSSStyle()}>
            <div id="alert-inner-wrapper" style={this.warnCSSStyle.getInnerWrapperCSSStyle()}>
                <div  onClick={this.onCloseButtonClick} style={this.warnCSSStyle.getCloseButtonDivCSSStyle()}>
                        <img width='20px' height='20px' src={this.getContext().getResources().getImage("close.svg")}/>
                </div>
                {/* <div style={this.warnCSSStyle.getAlertImageDivCSSStyle()}>
                    <img width='150px' height='150px' src={this.getContext().getResources().getImage("warn.svg")}/>
                </div> */}
                <div style={{width:"100%", display:"none",height:"30px",textAlign:"center",lineHeight:"30px",fontSize:"25px",fontWeight:900,color:"#000000",marginBottom:"30px"}}>
                    <label>{this.getContext().getResources().getString(Strings.alert_warning)}</label>
                </div>
                <div style={this.warnCSSStyle.getAlertMessageDivCSSStyle()}>
                        {uiState.alertMessage}
                </div>
                <div style={this.warnCSSStyle.getButtonDivCSSStyle()}>
                    <ButtonComponent onClick={this.onButtonClick} style={new AlertButtonCSSStyle(uiProps.context, "#FFFFFF")} context={uiProps.context} label={uiState.buttonTitle}/>

                </div>

            </div>
           
       </div>
        );
    }
    private getAuthenticateAlertView(uiProps:AlertComponentProps,uiState:AlertComponentState):JSX.Element
    {
        return(
            <div style={this.warnCSSStyle.getWrapperCSSStyle()}>
            <div id="alert-inner-wrapper" style={this.warnCSSStyle.getInnerWrapperCSSStyle()}>
                <div  onClick={this.onCloseButtonClick} style={this.warnCSSStyle.getCloseButtonDivCSSStyle()}>
                        <img width='20px' height='20px' src={this.getContext().getResources().getImage("close.svg")}/>
                </div>
                {/* <div style={this.warnCSSStyle.getAlertImageDivCSSStyle()}>
                    <img width='150px' height='150px' src={this.getContext().getResources().getImage("warn.svg")}/>
                </div> */}
                <div style={{width:"100%", display:"none",height:"30px",textAlign:"center",lineHeight:"30px",fontSize:"25px",fontWeight:900,color:"#000000",marginBottom:"30px"}}>
                    <label>{this.getContext().getResources().getString(Strings.alert_confirm)}</label>
                </div>
                <div style={this.warnCSSStyle.getAlertMessageDivCSSStyle()}>
                        {uiState.alertMessage}
                </div> 
                <div style={this.warnCSSStyle.getAuthenticateButtonDivCSSStyle()}>
                <div id="alert-authenticate-button-margin" style={{width:'140px'}}>
                <ButtonComponent onClick={this.onButtonClick} style={new AlertButtonCSSStyle(uiProps.context, "#FFFFFF")} context={uiProps.context} label={uiState.buttonTitle}/>
                    </div>
                    <div style={{width:'140px'}}>
                    <ButtonComponent onClick={this.onCloseButtonClick} style={new AlertButtonCSSStyle(uiProps.context, "#FFFFFF")} context={uiProps.context} label={uiProps.context.getResources().getString(Strings.cancel)}/> 
                </div>
                </div>

            </div>
           
       </div>
        );
    }
    private getMobileSuccessAlertView(uiProps:AlertComponentProps,uiState:AlertComponentState,cssStyle:AlertCSSStyle):JSX.Element
    {
        return(
            <div style={cssStyle.getMobileWrapperCSSStyle()}>
            <div id="alert-inner-wrapper" style={cssStyle.getInnerWrapperCSSStyle()}>
                <div  onClick={this.onCloseButtonClick} style={cssStyle.getMobileCloseButtonDivCSSStyle()}>
                        <img width='20px' height='20px' src={this.getContext().getResources().getImage("close.svg")}/>
                </div>
                {/* <div style={cssStyle.getMobileAlertImageDivCSSStyle()}>
                    <img width='70px' height='70px' src={this.getContext().getResources().getImage("successcheck.svg")}/>
                </div> */}
                 <div style={{width:"100%", display:"none",height:"20px",marginTop:"20px",textAlign:"center",lineHeight:"20px",fontSize:"20px",fontWeight:900,color:"#000000",marginBottom:"30px"}}>
                    <label>{this.getContext().getResources().getString(Strings.alert_success)}</label>
                </div>
                <div style={cssStyle.getMobileAlertMessageDivCSSStyle()}>
                        {uiState.alertMessage}
                </div>
                <div onClick={this.onButtonClick} style={{marginLeft:"auto",marginRight:"auto",width:"160px"}}>
                    <ButtonComponent onClick={this.onButtonClick} style={new AlertButtonCSSStyle(uiProps.context, "#FFFFFF")} context={uiProps.context} label={uiState.buttonTitle}/>

                </div>

            </div>
           
       </div>
        );
            
    }

    private getMobileErrorAlertView(uiProps:AlertComponentProps, uiState:AlertComponentState):JSX.Element
    {
        return(
            <div style={this.errorCSSStyle.getMobileWrapperCSSStyle()}>
            <div id="alert-inner-wrapper" style={this.errorCSSStyle.getInnerWrapperCSSStyle()}>
                <div   onClick={this.onCloseButtonClick} style={this.errorCSSStyle.getMobileCloseButtonDivCSSStyle()}>
                        <img width='20px' height='20px' src={this.getContext().getResources().getImage("close.svg")}/>
                </div>
                {/* <div style={this.errorCSSStyle.getMobileAlertImageDivCSSStyle()}>
                    <img width='70px' height='70px' src={this.getContext().getResources().getImage("errorcircle.svg")}/>
                </div> */}
                 <div style={{width:"100%", display:"none",height:"20px",marginTop:"20px",textAlign:"center",lineHeight:"20px",fontSize:"20px",fontWeight:900,color:"#000000",marginBottom:"30px"}}>
                    <label>{this.getContext().getResources().getString(Strings.alert_error)}</label>
                </div>
                <div style={this.errorCSSStyle.getMobileAlertMessageDivCSSStyle()}>
                        {uiState.alertMessage}
                </div>
                <div onClick={this.onButtonClick} style={{marginLeft:"auto",marginRight:"auto",width:"160px"}}>
                    <ButtonComponent onClick={this.onButtonClick} style={new AlertButtonCSSStyle(uiProps.context, "#FFFFFF")} context={uiProps.context} label={uiState.buttonTitle}/>

                </div>

            </div>
           
       </div>
        );
    }

    private getMobileWarnAlertView(uiProps:AlertComponentProps,uiState:AlertComponentState):JSX.Element
    {
        return(
            <div style={this.warnCSSStyle.getMobileWrapperCSSStyle()}>
            <div id="alert-inner-wrapper" style={this.warnCSSStyle.getInnerWrapperCSSStyle()}>
                <div   onClick={this.onCloseButtonClick} style={this.warnCSSStyle.getMobileCloseButtonDivCSSStyle()}>
                        <img width='20px' height='20px' src={this.getContext().getResources().getImage("close.svg")}/>
                </div>
                {/* <div style={this.warnCSSStyle.getMobileAlertImageDivCSSStyle()}>
                    <img width='70px' height='70px' src={this.getContext().getResources().getImage("warn.svg")}/>
                </div> */}
                 <div style={{width:"100%", display:"none",height:"20px",marginTop:"20px",textAlign:"center",lineHeight:"20px",fontSize:"20px",fontWeight:900,color:"#000000",marginBottom:"30px"}}>
                    <label>{this.getContext().getResources().getString(Strings.alert_warning)}</label>
                </div>
                <div style={this.warnCSSStyle.getMobileAlertMessageDivCSSStyle()}>
                        {uiState.alertMessage}
                </div>
                <div style={{marginLeft:"auto",marginRight:"auto",width:"160px"}}>
                    <ButtonComponent onClick={this.onButtonClick} style={new AlertButtonCSSStyle(uiProps.context, "#FF8F18")} context={uiProps.context} label={uiState.buttonTitle}/>

                </div>

            </div>
           
       </div>
        );
    }
    private getMobileAuthenticateAlertView(uiProps:AlertComponentProps,uiState:AlertComponentState):JSX.Element
    {
        return(
            <div style={this.warnCSSStyle.getMobileWrapperCSSStyle()}>
            <div  id="alert-inner-wrapper" style={this.warnCSSStyle.getInnerWrapperCSSStyle()}>
                <div   onClick={this.onCloseButtonClick} style={this.warnCSSStyle.getMobileCloseButtonDivCSSStyle()}>
                        <img width='20px' height='20px' src={this.getContext().getResources().getImage("close.svg")}/>
                </div>
                {/* <div style={this.warnCSSStyle.getMobileAlertImageDivCSSStyle()}>
                    <img width='70px' height='70px' src={this.getContext().getResources().getImage("warn.svg")}/>
                </div> */}
                 <div style={{width:"100%", display:"none",height:"20px",marginTop:"20px",textAlign:"center",lineHeight:"20px",fontSize:"20px",fontWeight:900,color:"#000000",marginBottom:"30px"}}>
                    <label>{this.getContext().getResources().getString(Strings.alert_confirm)}</label>
                </div>
                <div style={this.warnCSSStyle.getMobileAlertMessageDivCSSStyle()}>
                        {uiState.alertMessage}
                </div>
                <div style={this.warnCSSStyle.getMobileAuthenticateButtonDivCSSStyle()}>
                <div id="alert-authenticate-button-margin" style={{width:'110px'}}>
                <ButtonComponent onClick={this.onButtonClick} style={new AlertButtonCSSStyle(uiProps.context, "#FFFFFF")} context={uiProps.context} label={uiState.buttonTitle}/>
                    </div>
                    <div style={{width:'110px'}}>
                    <ButtonComponent onClick={this.onCloseButtonClick} style={new AlertButtonCSSStyle(uiProps.context, "#FFFFFF")} context={uiProps.context} label={uiProps.context.getResources().getString(Strings.cancel)}/> 
                </div>
                </div>

            </div>
           
       </div>
        );
    }
    private onButtonClick():void
    {
        (this.getUIComponentHandler() as AlertComponentHandler).onClick('');
    }

    private onCloseButtonClick():void
    {
        (this.getUIComponentHandler() as AlertComponentHandler).onCloseButtonClick();
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/alert/alertview.tsx